import React from 'react';
import ReactDOM from 'react-dom';
import AppRouter from "./commons/components/application/AppRouter";
//import * as serviceWorker from './serviceWorker';

import { store, persistor } from './commons/components/application/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'

import i18next from 'i18next';
import LngDetector from 'i18next-browser-languagedetector';
import { I18nextProvider } from 'react-i18next';

import { initApiClient } from "./api/axiosClient"

// translations
import esTranslations from './config/translations/es.json';
import enTranslations from './config/translations/en.json';

// Import mixpanel requirements
import mixpanel from 'mixpanel-browser';
import { MixpanelProvider } from 'react-mixpanel';

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons';
import { envConfig } from './config/config';

import { QueryClientProvider } from 'react-query';
import { queryClient } from './config/reactQuery';

// --- Check user and clear storage ---
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function parseJwt(token) {
  if (!token) return null;
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
}

const token = getCookie('auth_token');
const userFromToken = parseJwt(token);

const persisted = localStorage.getItem('persist:local');
let userFromStorage = null;
if (persisted) {
  try {
    var parsed = JSON.parse(persisted);
    if (parsed && parsed.login) {
      var loginObj = JSON.parse(parsed.login);
      userFromStorage = loginObj && loginObj.admin ? loginObj.admin.id : null;
    }
  } catch (e) {
    userFromStorage = null;
  }
}

if (userFromStorage && userFromToken && userFromStorage !== userFromToken.id) {
  localStorage.removeItem('persist:local');
  localStorage.removeItem('persist:session');
  localStorage.removeItem('auth_token');
  localStorage.removeItem('ray_auth');
}

  
// Add all icons to the library so you can use it in your page
library.add(fas, fab)

// inicializacion i18n
i18next
    .use(LngDetector)
    .init({
        fallbackLng: 'en',
        interpolation: { escapeValue: false },  // React already does escaping
        detection: {
            order: ['navigator']
        },
        resources: {
            es: {
                common: esTranslations
            },
            en: {
                common: enTranslations
            }
        },
        react: {
            bindStore: false
        }
    });

// Inicialización de Mixpanel
mixpanel.init(envConfig.mixpanelToken, { batch_requests: true })

function beforeLift() {
    // No token management needed - using HTTP-only cookies exclusively
}

initApiClient(store);

const Root = (
    <Provider store={store}>
        <PersistGate persistor={persistor} onBeforeLift={beforeLift}>
            <I18nextProvider i18n={i18next}>
                <QueryClientProvider client={queryClient}>
                    <MixpanelProvider mixpanel={mixpanel}>
                        <AppRouter loggedIn={store.getState().login.loggedIn} />
                    </MixpanelProvider>
                </QueryClientProvider>
            </I18nextProvider>
        </PersistGate>
    </Provider>
);

ReactDOM.render(Root, document.getElementById('wrapper'));

// If you want your home to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA

//TODO Comentar para que funcionen los workers de OneSignal
//serviceWorker.unregister();

// Commented by adrian because it leads conflicts with
// the OneSignal's service workers.
//amp serviceWorker.unregister();
